module.exports = __webpack_public_path__ + "static/digital-e197a0fa98738d276f787ba550c361fe.jpg";